import { ModalConfig } from '@shared/interfaces/modal/modal-config';
import { MeterframeCloseComponent } from '@shared/modals/meterframe/meterframe-close/meterframe-close.component';

export const meterframeCloseModalConfig: ModalConfig = {
  component: MeterframeCloseComponent,
  title: 'meterFrame.close.title',
  actions: [
    {
      type: 'primary',
      label: 'system.button.disband',
      method: 'submit'
    },
    {
      type: 'secondary',
      label: 'system.button.cancel',
      closeOnClick: true
    },
  ]
}
